export const messagesStatistics = {
    pt: {
        message:{
            above: "acima de",
            accessesByDay: "Acessos por dia",
            accessesByHour: "Acessos por hora",
            age: "Idade",
            ageAverage: "Média de idade",
            abandonment: "Abandonos",
            birthDate: "Data de Nascimento",
            completed: "Completos",
            density: "Densidade",
            devices: "Dispositivos",
            engagement: "Engajamento",
            exportReport: "Exportar Relatório",
            female: "Feminino",
            form: "Formulário",
            noForm: "Sem formulário",
            friday: "Sexta-feira",
            from: "de",
            gender: "Sexo",
            heatMap: "Mapa de calor",
            impressions: "Impressões",
            inserts: "Inserções",
            male: "Masculino",
            monday: "Segunda-feira",
            newUsers: "Novos Usuários",
            notDeclared: "Não declarado",
            other: "Outro",
            registrationType: "Tipo de cadastro",
            rejection: "Rejeição",
            uniqueUsers: "Usuários Únicos",
            saturday: "Sábado",
            screenTime: "Tempo em Tela",
            screenTimeAvg: "Tempo Médio em Tela",
            sunday: "Domingo",
            thursday: "Quinta-feira",
            to: "até",
            tooltipAccesses: "Número de vezes que os usuários acessaram o Wi-Fi (um mesmo usuário pode acessar mais de uma vez)",
            tooltipAccessesByDay: "Total de acessos gerados em cada dia da semana",
            tooltipAccessesByHour: "Total de acessos gerados em cada hora",
            tooltipAge: "Quantidade por idade dos usuários cadastrados",
            tooltipAgeAverage: "Média de idade dos usuários cadastrados",
            tooltipDevices: "Sistema operacional dos dispositivos que acessaram o Wi-Fi",
            tooltipEngagement: "Percentual dos usuários que foram até o final da impactação e acessaram a internet",
            tooltipGender: "Sexo dos usuários cadastrados. (Ao realizar o cadastro, o usuário pode escolher por não declarar seu sexo)",
            tooltipHeatMap: "Escala de acessos gerados em cada hora.",
            tooltipImpressions: "<p>Impressões: Número de telas vistas pelos usuários. Cada tela diferente mostrada ao usuário, conta como uma impressão. Em um único acesso, podem ser impressas até 3 telas diferentes ao mesmo usuário</p> Viewability: Seguindo os padrões estabelecidos pelo International Advertising Bureau (IAB), esta métrica conta apenas os banners com pelo menos 50% de sua área (em pixels) visível ao usuário por no mínimo um segundo",
            tooltipRegistrationType: "Ao realizar o cadastro, o usuário pode optar por fazê-lo respondendo o seu e-mail, nome completo, data de nascimento, telefone (opcional) e sexo; ou utilizando o preenchimento automático através do Facebook",
            tooltipRejection: "Percentual dos usuários que, em algum momento da impactação, clicaram no botão “X” no canto superior direito para sair da impactação e acessar a internet",
            tooltipScreenTimeAvg: "Média do tempo passado em cada tela das campanhas",
            tooltipTotalUsers: "Total de usuários do WiFeed",
            tooltipUsers: "Usuários únicos: contagem única de pessoas que acessaram o Wi-Fi no dia.<br>Novos usuários: novos cadastros no dia.",
            totalUsers: "Total de usuários",
            tuesday: "Terça-feira",
            viewability: "Viewability",
            wednesday: "Quarta-feira",
            years: "anos",
            topLocals: "Locais mais acessados",
            graphHelperText: "* As informações contidas no gráfico são consideradas somente até o dia anterior.",
            mostViewedSites: "Sites mais acessados",
            mostViewedIps: "IP's mais acessados",
            mostUsedProtocols: "Protocolos mais utilizados",
            totalBandwidth: "Total de banda utilizada",
            totalClients: "Total de clientes"
        }
    },
    es: {
        message:{
            above:"encima de",
            accessesByDay:"Hits por día",
            accessesByHour:"Acceso por hora",
            age:"Años",
            ageAverage:"Edad promedio",
            abandonment:"Abandonados",
            birthDate:"Fecha de nacimiento",
            completed:"Completo",
            density:"Densidad",
            devices:"Dispositivos",
            engagement:"Compromiso",
            exportReport:"Reporte de exportacion",
            female:"Femenino",
            form:"Formulario",
            noForm: "Sin Formulario",
            friday:"Viernes",
            from:"en",
            gender:"Sexo",
            heatMap:"Mapa de calor",
            impressions:"Impresiones",
            inserts:"Inserciones",
            male:"Masculino",
            monday:"Lunes",
            newUsers:"Usuarios nuevos",
            notDeclared:"No declarado",
            other:"Otro",
            registrationType:"Tipo de registro",
            rejection:"Rechazo",
            uniqueUsers:"Usuarios únicos",
            saturday:"Sábado",
            screenTimeAvg:"Tiempo promedio en la pantalla",
            sunday:"Domingo",
            thursday:"Jueves",
            to:"Hasta que",
            tooltipAccesses:"Número de veces que los usuarios han accedido a Wi-Fi (el mismo usuario puede acceder más de una vez)",
            tooltipAccessesByDay:"Acceso total generado cada día de la semana",
            tooltipAccessesByHour:"Acceso total generado cada hora",
            tooltipAge:"Cantidad por edad de usuarios registrados",
            tooltipAgeAverage:"Edad promedio de usuarios registrados",
            tooltipDevices:"Sistema operativo de dispositivos que accedieron a Wi-Fi",
            tooltipEngagement:"Porcentaje de usuarios que fueron al final del impacto y accedieron a Internet",
            tooltipGender:"Sexo de usuarios registrados (al registrarse, el usuario puede elegir no declarar su género)",
            tooltipHeatMap:"Escala de acceso generada cada hora",
            tooltipImpressions:"<p> Imprime el número de pantallas vistas por los usuarios. Cada pantalla diferente que se muestra al usuario cuenta como una impresión. En un solo acceso, hasta 3 pantallas diferentes se pueden imprimir en el mismo usuario </p> Visibilidad: siguiendo los patrones Establecido por la Oficina de Publicidad Internacional (IAB), esta métrica solo tiene pancartas con al menos el 50% de su área (en píxeles) visibles para el usuario por al menos un segundo ",
            tooltipRegistrationType:"Al registrarse, el usuario puede optar por hacerlo respondiendo a su correo electrónico, nombre completo, fecha de nacimiento, teléfono (opcional) y sexo; o utilizando el relleno automático a través de Facebook",
            tooltipRejection:"Porcentaje de usuarios que, en algún momento del impacto, hicieron clic en el botón “X” en la esquina superior derecha para salir del impacto y acceder a Internet",
            tooltipScreenTimeAvg:"Tiempo promedio dedicado a cada pantalla de las campañas",
            tooltipTotalUsers:"Total de usuarios de WiFeed",
            tooltipUsers:"Usuarios únicos: contagem única de pessoas que acessaram o Wi-Fi no dia.<br>Novos usuários: Nuevas inscripciones en el día ",
            totalUsers:"Total de usuarios",
            tuesday:"Martes",
            viewability:"Visibilidad",
            wednesday:"Miércoles",
            years:"años",
            topLocals: "Lugares más visitados",
            graphHelperText: "* La información contenida en el gráfico sólo se considera hasta el día anterior.",
            mostViewedSites: "Sitios más vistos",
            mostViewedIps: "IP más vistas",
            mostUsedProtocols: "Protocolos más utilizados",
            totalBandwidth: "Ancho de banda total utilizado",
            totalClients: "Clientes totales"
        }
    },
    en: {
        message:{
            above: "above",
            accessesByDay: "Accesses by day",
            accessesByHour: "Accesses by hour",
            abandonment: "Abandonment",
            age: "Age",
            ageAverage: "Age Average",
            birthDate: "Birth date",
            completed: "Completed",
            density: "Density",
            devices: "Devices",
            engagement: "Engagement",
            exportReport: "Export Report",
            female: "Female",
            form: "Form",
            noForm: "No form",
            friday: "Friday",
            from: "from",
            gender: "Gender",
            heatMap: "Heat map",
            impressions: "Impressions",
            inserts: "Inserts",
            male: "Male",
            monday: "Monday",
            newUsers: "New Users",
            notDeclared: "Undeclared",
            other: "Other",
            registrationType: "Registration type",
            rejection: "Rejection",
            uniqueUsers: "Unique Users",
            saturday: "Saturday",
            screenTime: "Screen Time",
            screenTimeAvg: "Average Screen Time",
            sunday: "Sunday",
            thursday: "Thursday",
            to: "to",
            tooltipAccesses: "Number of times that users accessed the Wi-Fi (one user can access more than once)",
            tooltipAccessesByDay: "Total accesses generated on each day of the week",
            tooltipAccessesByHour: "Total accesses generated on each hour",
            tooltipAge: "Number by age of registered users",
            tooltipAgeAverage: "Average age of registered users",
            tooltipDevices: "Operating system of devices that accessed Wi-Fi",
            tooltipEngagement: "Percentage of users who went to the end of the impaction and accessed the internet",
            tooltipGender: "Gender of registered users. (When registering, the user can choose not to declare their gender)",
            tooltipHeatMap: "Scale of accesses generated in each hour.",
            tooltipImpressions: "<p>Impressions: Number of screens seen by the users. Each different screen shown to a user, counts as an impression. During a single access, up to 3 different screens can be printed to the same user</p> Viewability: Seguindo os padrões estabelecidos pelo International Advertising Bureau (IAB), esta métrica conta apenas os banners com pelo menos 50% de sua área (em pixels) visível ao usuário por no mínimo um segundo",
            tooltipRegistrationType: "When registering, the user can choose to do so by answering his e-mail, full name, date of birth, telephone (optional) and gender; or using autofill through Facebook",
            tooltipRejection: "Percentage of users who, at some point during the impaction, clicked on the “X” button in the upper right corner to exit the impaction and access the internet",
            tooltipScreenTimeAvg: "Average time spent on each campaign screen",
            tooltipTotalUsers: "Total WiFeed users",
            tooltipUsers: "Unique users: single count of people who accessed the Wi-Fi throughout the day.<br>New user: new registrations on the day\n.",
            totalUsers: "Total users",
            tuesday: "Tuesday",
            viewability: "Viewability",
            wednesday: "Wednesday",
            years: " years",
            topLocals: "Most accessed locations",
            graphHelperText: "* The information contained in the graph is only considered up to the previous day.",
            mostViewedSites: "Most viewed sites",
            mostViewedIps: "Most viewed IPs",
            mostUsedProtocols: "Most used protocols",
            totalBandwidth: "Total bandwidth used",
            totalClients: "Total clients"
        }
    }
}
